module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', [(_vm.exercise.adherence) ? _c('v-list-tile-avatar', [_c('adherence-progress', {
    model: {
      value: (_vm.exercise.adherence),
      callback: function($$v) {
        _vm.$set(_vm.exercise, "adherence", $$v)
      },
      expression: "exercise.adherence"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n      " + _vm._s(_vm.exercise.name) + "\n    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._l((_vm.fields), function(field) {
    return [(_vm.getAdherence(field) || _vm.getField(field)) ? _c('v-chip', {
      key: (field + "-" + (_vm.exercise.id)),
      staticClass: "v-chip--x-small pa-0 ml-1",
      attrs: {
        "outline": "",
        "outlined": "",
        "label": ""
      }
    }, [(_vm.exercise.adherence) ? _c('span', [_c('strong', [_vm._v(_vm._s(field) + ":")]), _vm._v(" " + _vm._s(_vm.getAdherence(field)) + "\n          ")]) : _c('span', [_c('strong', [_vm._v(_vm._s(field) + ":")]), _vm._v(" " + _vm._s(_vm.getField(field)) + "\n          ")])]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), (_vm.exercise.pain_level) ? _c('v-list-tile-action', [_c('v-progress-circular', {
    attrs: {
      "color": "error",
      "width": "3",
      "size": "26",
      "value": _vm.exercise.pain_level * 10
    }
  }, [_vm._v("\n      " + _vm._s(_vm.exercise.pain_level) + "\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154d7c5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/ExerciseListItem.vue
// module id = 1334
// module chunks = 9